<template>
  <div>
    <div class="white black--text"  v-if="dispatchData">
      <div v-if="orderData">
        <v-row>
          <v-col class="headline font-weight-light">
            Client Check-in Time
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="orderData.fulfillmentInfo">
            <v-icon>event</v-icon>{{moment(orderData.fulfillmentInfo.date)}}
          </v-col>
          <v-col v-if="orderData.fulfillmentInfo">
            <v-icon>schedule</v-icon>{{orderData.fulfillmentInfo.time}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="headline font-weight-light">
            Crew Check-in Time
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="orderData.fulfillmentInfo.crewTime">
            <v-btn @click="crewStartTimeDialog = true" text>
              <v-icon>schedule</v-icon>
              Start time:
              {{orderData.fulfillmentInfo.crewTime}}
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn @click="crewStartTimeDialog = true" outlined>
              <v-icon>schedule</v-icon>Set start time
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col @click="openEventDateTimeDialog" v-if="orderData.fulfillmentInfo.estimatedFinishTime">
            <v-btn  @click="openEventDateTimeDialog" text>
              <v-icon>schedule</v-icon>
              Finish Time
              {{orderData.fulfillmentInfo.estimatedFinishTime}}
            </v-btn>
            <span class="text-caption">*estimated</span>
          </v-col>
          <v-col v-else>
            <v-btn @click="openEventDateTimeDialog" outlined>
              <v-icon>schedule</v-icon>Set start time
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="headline font-weight-light"> Crew Check-in Location </v-col>
        </v-row>
        <v-list v-if="orderData.fulfillmentInfo.crewMeetupLocation">
          <v-list-item>
            <a style="text-decoration:none"
               class="blue--text"
               target="_blank"
               :href="'https://www.google.com/maps/place/' + orderData.fulfillmentInfo.crewMeetupLocation.formatted_address">
              <div><v-icon class="blue--text">location_pin</v-icon> {{orderData.fulfillmentInfo.crewMeetupLocation.formatted_address}}</div>
            </a>
            <v-btn icon @click="removeMeetupLocation">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
        <locations-autocomplete
            v-else
            @locationFound="saveMeetupLocation"
            id="1"
            class="mb-4 mt-2"
        ></locations-autocomplete>

        <v-row>
          <v-col class="headline font-weight-light"> Fulfillment Location </v-col>
        </v-row>
        <v-row>
          <v-list v-if="orderData.locations">
            <v-list-item v-if="orderData.locations.length === 0">
              <v-list-item-avatar><v-icon>add_location</v-icon></v-list-item-avatar>
              <v-list-item-content>
                No locations
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="local in orderData.locations" :key="local.created">
              <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + local.formatted_address">
                <div><v-icon class="red--text">location_pin</v-icon> {{local.name}}</div>
              </a>
            </v-list-item>
          </v-list>
        </v-row>
      </div>
      <div class="pb-4 pt-4 headline font-weight-light">Services Required</div>

      <div>
        <service-roles :id="id" :dispatchData="dispatchData" class="pb-3"></service-roles>
      </div>
      <div class="pb-4 headline font-weight-light">Connect Service Provider</div>
      <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>
      <segment-picker @contactsFound="contactsPicked"></segment-picker>
      <div v-if="dispatchData.segments">
        <v-expansion-panels>
          <v-expansion-panel
              v-for="segment in dispatchData.segments"
              :key="segment.id"
          >
            <v-expansion-panel-header :color="segment.colour">
              <div class="subtitle-1">{{segment.name}}</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list-item
                  v-for="contact in segment.contacts"
                  :key="contact.phoneNumber"
              >
                <v-list-item-title>{{contact.name}}</v-list-item-title>
                <v-list-item-icon>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-on="on" v-bind="attrs">menu</v-icon>
                    </template>
                    <v-list>
                      <v-list-item @click="addContractor(contact)">
                        <v-list-item-title>Add contractor</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="removeContact(contact)">
                        <v-list-item-title>Remove contact</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-icon>
              </v-list-item>
            </v-expansion-panel-content>
            <v-card elevation="0">
              <v-card-text>
                <v-textarea
                    rows="2"
                    outlined
                    label="Send Text"
                    v-model="segment.message"
                    clearable
                ></v-textarea>
                Assigned role:
                <v-combobox
                    dense
                    label="Select Service Provider Role"
                    v-model="segment.chip"
                    :items="serviceRoleItems"
                    chips
                    solo
                    clearable
                    class="elevation-0"
                    append-outer-icon="check"
                    @click:append-outer="updateDispatch"
                >
                  <template  v-slot:selection="{ attrs, item}">
                    <div
                        v-bind="attrs"
                    >
                      <strong class="blue--text">{{ item }}</strong>&nbsp;
                    </div>
                  </template>
                </v-combobox>
                Auto responses:
                <v-col>
                  <v-btn class="ma-1 blue--text" outlined rounded small @click="textEventTimeDate(segment)">Event info</v-btn>
                  <v-btn class="ma-1 green--text" outlined rounded small @click="textRoutePlan(segment)">Route details</v-btn>
                  <v-btn class="ma-1 black--text" outlined rounded small @click="textPayOutPlan(segment)">Payout</v-btn>

                  <v-btn class="ma-1 black--text" outlined rounded small @click="textInstructions(segment)">Instructions</v-btn>

                </v-col>

              </v-card-text>
              <v-card-actions>
                <v-btn small text @click="deleteSegment(segment)"><v-icon class="red--text">close</v-icon>remove</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!segment.message" class="blue--text" outlined @click="previewSegmentText(segment)" >Preview Send <v-icon>send</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="headline font-weight-thin pt-4 pb-4" >Selected service providers</div>
      <v-list-item
          v-for="contact in dispatchData.contractors"
          :key="contact.phoneNumber"
      >
        <v-list-item-title>{{contact.name}}</v-list-item-title>
        <v-list-item-icon @click="removeContractor(contact)">
          <v-icon class="warning--text">close</v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-btn class="pink white--text" block @click="completeDispatch">Dispatch complete</v-btn>
    </div>
    <v-dialog v-model="eventDateTimeDialog"
              ref="dialog"
              persistent
              width="500px"
    >

      <v-card>
        <v-card-title>
          <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">Add to Schedule</div>
        </v-card-title>
        <v-card-text v-if="orderData">
          <div class="subtitle-1">Estimated Finish Time</div>
          <v-divider></v-divider>
          <date-time-picker
              :orderTime="time"
              :orderDate="date"
              @dateFound="eventDatePicked"
              @timeFound="eventTimePicked"
          ></date-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="eventDateTimeDialog = false">cancel</v-btn>
          <v-btn @click="setEventToCalendar" class="blue" dark>Add to Calendar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="crewStartTimeDialog"
              ref="dialog"
              persistent
              width="500px"
    >

      <v-card>
        <v-card-title>
          <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">Set Crew Time</div>
        </v-card-title>
        <v-card-text v-if="orderData">
          <div class="subtitle-1">Start Time</div>
          <v-divider></v-divider>
          <date-time-picker
              :orderTime="crewTime"
              :orderDate="crewDate"
              @dateFound="crewStartDatePicked"
              @timeFound="crewStartTimePicked"
          ></date-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="crewStartTimeDialog = false">cancel</v-btn>
          <v-btn @click="setCrewStartTime" class="blue" dark>
            Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="orderDetailsDialog"
              ref="dialog"
              persistent
              width="500px"
    >

      <v-card>
        <v-card-title>
          <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">{{orderDetailsDialogInfo.title}}</div>
        </v-card-title>
        <v-card-text >
          <div class="subtitle-1">Date & Time</div>
          <v-divider></v-divider>
          <div class="subtitle-1"></div>
          <v-card-title class="headline" v-if="orderData">
            <v-icon>event</v-icon>{{moment(orderData.fulfillmentInfo.date)}}
          </v-card-title>
          <v-card-title
              v-if="orderData">
            <v-icon>schedule</v-icon>
            <div>Start time: </div>
            <div  class="headline">
              {{momentTime(orderData.fulfillmentInfo.crewTime)}}
            </div>

          </v-card-title>
          <v-card-subtitle
              class="subtitle-1"
              v-if="orderData">
            Estimated finish:
            {{momentTime(orderData.fulfillmentInfo.estimatedFinishTime)}}
          </v-card-subtitle>
        </v-card-text>

        <v-card-text v-if="orderDetailsDialogInfo.routeDetails">
          <div class="subtitle-1">Trip Locations</div>
          <v-divider></v-divider>
          <div class="subtitle-1"></div>
        </v-card-text>
        <v-card-text v-if="orderDetailsDialogInfo.routeDetails">
          <v-row  v-if="includeMeetupLocation">
            <v-card-text v-if="orderData.fulfillmentInfo.crewMeetupLocation">

              <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + orderData.fulfillmentInfo.crewMeetupLocation.formatted_address">
                <div><v-icon class="red--text">location_pin</v-icon> {{orderData.fulfillmentInfo.crewMeetupLocation.formatted_address}}</div>
              </a>
            </v-card-text>
          </v-row>
          <v-row>
            <v-list v-if="orderDetailsDialogInfo.routeDetails.locations">
              <v-list-item v-if="orderDetailsDialogInfo.routeDetails.locations.length === 0">
                <v-list-item-avatar><v-icon>add_location</v-icon></v-list-item-avatar>
                <v-list-item-content>
                  No locations
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-for="local in orderDetailsDialogInfo.routeDetails.locations" :key="local.created">
                <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + local.formatted_address">
                  <div><v-icon class="red--text">location_pin</v-icon> {{local.name.substring(local.name.indexOf(" ") + 1)}}</div>
                </a>
              </v-list-item>
            </v-list>
            <v-card-text>
              <v-checkbox
                  v-model="includeMeetupLocation"
                  label="Include meet-up location"
              ></v-checkbox>
            </v-card-text>
          </v-row>
        </v-card-text>

        <v-card-text v-if="orderDetailsDialogInfo.payoutDetails">
          <div class="subtitle-1">Payout Details</div>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text v-if="orderDetailsDialogInfo.payoutDetails">
          <v-row>
            <v-col>
              <div>Service Required:</div>
            </v-col>
            <v-col>
              {{orderDetailsDialogInfo.payoutDetails.serviceRequired}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>{{orderDetailsDialogInfo.payoutDetails.text}}</v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-if="orderDetailsDialogInfo.instructions">
          <div class="subtitle-1">Instructions</div>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text v-if="orderDetailsDialogInfo.instructions">
          <v-row v-for="(step, i) in orderDetailsDialogInfo.instructions" :key="i">
            <v-col>
              <div>{{step}}</div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="orderDetailsDialog = false">close</v-btn>
          <v-btn @click="handleChatPill" outlined class="blue--text">
            Preview text</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendMessageDialog"
              ref="dialog"
              persistent
              width="500px"
    >
      <v-card>
        <v-card-title>
          <div class="white
                        black--text
                        text-xs-center
                        font-weight-thin
                        headline">Send Text</div>
        </v-card-title>
        <v-card-text>
          <v-textarea
              v-model="textPreview"
              rows="3"
              clearable
          >
          </v-textarea>
<!--          &lt;!&ndash; picked image&ndash;&gt;-->
<!--          <div v-if="mediaUrl">-->
<!--            <v-img contain :src="mediaUrl" aspect-ratio="2.5"></v-img>-->
<!--          </div>-->
          <div class="headline font-weight-thin">To: </div>
          <v-list v-for="user in usersInSegment" :key="user.phoneNumber">
            <v-list-item>
              <v-list-item-content class="text-h6 font-weight-regular">
                {{user.name}}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="sendMessageDialog = false">close</v-btn>
          <v-btn  class="blue white--text"
                  :disabled="msgNotValid"
                  @click="sendText">
            send
            <v-icon>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import moment from 'moment'
import {addDoc, collection, doc, onSnapshot, setDoc, updateDoc} from "firebase/firestore";
import {getFunctions, httpsCallable} from "firebase/functions";
import {v1 as uuidv1, v4 as uuid} from "uuid";

export default {
  components: {},
  props: ["id"],
  data () {
    return {
      dispatchData: undefined,
      serviceRoleItems: [],
      textMessage: 'Auto generated text',
      orderData: null,
      eventDateTimeDialog: false,
      time: null,
      date: null,
      crewTime: null,
      crewDate: null,
      crewStartTimeDialog: false,
      orderDetailsDialog: false,
      sendMessageDialog: false,
      orderDetailsDialogInfo: {
        title: '',
        linkType: '', //eventDate, routePlan, payout
        serviceDate: '',
        meetUpTime: '',
        estimatedFinishTime: '',
        routeDetails: null,
        payoutDetails: null
      },
      textPreview: '',
      includeMeetupLocation: true,
      usersInSegment: []
    }
  },
  computed: {
    msgNotValid () {
      return !((this.usersInSegment.length !== 0) && (this.textPreview !== ''));
    },
    error () {
      return this.$store.getters.error
    },
    moment () {
      return (date) => {
        let day = moment(date).format('dddd, MMM Do')
        return day
      }
    },
    user () {
      return this.$store.getters.user
    },
    momentTime () {
      return (time) => {
        let timeStamp = moment(time, 'HH:mm').format('hh:mm A')
        return timeStamp
      }
    },
  },
  created() {
    let db = this.$store.state.db
    let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', this.id)
    onSnapshot(dispatchRef, res => {
      if (res.exists) {
        let data = res.data()
        this.dispatchData = data
        this.orderData = data.orderData
        let dispRoleItems = data.dispatchRoles
        if (dispRoleItems) {
          let item = []
          dispRoleItems.forEach(role => {
            return item.push(role.title)
          })
          this.serviceRoleItems = item
        }
        // console.log(data.orderData)
        let fulfillmentInfo = data.orderData.fulfillmentInfo
        if (fulfillmentInfo){
          this.date = fulfillmentInfo.date
          if (fulfillmentInfo.crewTime) {
            this.crewTime = fulfillmentInfo.crewTime
            this.crewDate = fulfillmentInfo.date
          } else {
            this.crewTime = fulfillmentInfo.time
            this.crewDate = fulfillmentInfo.date
          }
        }
        if(fulfillmentInfo.estimatedFinishTime) {
          this.time = fulfillmentInfo.estimatedFinishTime
        } else {
          if (data.orderData.status === 'success') {
            this.eventDateTimeDialog = true
          }
        }
      }
    })
  },
  methods: {
    previewSegmentText (segment) {
      // console.log(segment)
      this.usersInSegment = segment.contacts
      this.textPreview = segment.message
      this.sendMessageDialog = true
    },
    sendText () {
      let id = uuidv1()
      let users = this.usersInSegment
      let msgObj = {
        text:this.textPreview,
        created: Date.now(),
        id: id,
        direction: 'outgoing'
      }
      let db = this.$store.state.db
      for(let key in users) {
        let time = Date.now()
        let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/'+ users[key].connectedPhoneNumber + '/sms/'+ users[key].phoneNumber)
        let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + users[key].connectedPhoneNumber + '/sms/' + users[key].phoneNumber + '/messages')
        console.log(users[key])


        updateDoc(userSMSRef,{
          lastActive: time,
          lastMessage: msgObj.text,
          activeBooking: this.id
        })
            .then(()=> {
              let outgoingMsg = {...msgObj}
              outgoingMsg.created = time
              if (this.mediaUrl) {
                outgoingMsg.mediaUrl = this.mediaUrl
                // if (this.textMessage !== '') {
                //   outgoingMsg.text = ' '
                // }
              }
              return addDoc(userMsgsRef, outgoingMsg)
            })
            .catch(err => {
              this.$store.dispatch('setError', err)
              console.log(err)
            })
      }
      this.sendMessageDialog = false
    },
    handleChatPill () {
      let linkId = uuid()
      let textMsg
      let linkObj = {...this.orderDetailsDialogInfo}
      linkObj.serviceProviderName = this.user.name
      linkObj.serviceProviderMedia = this.user.thumbnailMediaUrl
      if (this.orderDetailsDialogInfo.linkType === 'eventDate') {
        textMsg = 'Job available: https://service.flexline.app/postedServices/'
            + this.user.serviceProviderId + '/'
            + linkId
      }
      if (this.orderDetailsDialogInfo.linkType === 'routePlan') {
        textMsg = 'Hey bro, here are the details for the job: https://service.flexline.app/postedServices/'
            + this.user.serviceProviderId + '/'
            + linkId
        if (this.includeMeetupLocation) {
          linkObj.routeDetails.meetUpLocation = this.orderData.fulfillmentInfo.crewMeetupLocation
        }
      }
      if (this.orderDetailsDialogInfo.linkType === 'payout') {
        textMsg = 'Hey bro, here are the details for the job: https://service.flexline.app/postedServices/'
            + this.user.serviceProviderId + '/'
            + linkId
        if (this.includeMeetupLocation) {
          linkObj.routeDetails.meetUpLocation = this.orderData.fulfillmentInfo.crewMeetupLocation
        }
      }
      if (this.orderDetailsDialogInfo.linkType === 'instructions') {
        textMsg = 'Here are the instructions for today: https://service.flexline.app/postedServices/'
            + this.user.serviceProviderId + '/'
            + linkId
        if (this.includeMeetupLocation) {
          linkObj.routeDetails.meetUpLocation = this.orderData.fulfillmentInfo.crewMeetupLocation
        }
      }
      let db = this.$store.state.db
      let serviceRef = doc(db, 'services', this.user.serviceProviderId, 'postedServices', linkId)
      let sharedLinksRef = doc(db, 'users', this.user.uid, 'sharedLinks', linkId)

      return setDoc(serviceRef, linkObj)
          .then (() => {
            this.textPreview = textMsg
            this.orderDetailsDialog = false
            this.sendMessageDialog = true
            // console.log(res)
          })
          .then (() => {
            let sharedLink = {...linkObj}
            sharedLink.orderData = this.orderData
            return setDoc(sharedLinksRef, sharedLink)
          })
          .catch(err => {
            console.log(err)
          })
      // console.log(textMsg)
      // console.log('open text preview')

    },
    textEventTimeDate (segment) {
      // console.log(segment)
      this.usersInSegment = segment.contacts
      let event = {
        time: this.momentTime(this.orderData.fulfillmentInfo.crewTime),
        date: this.moment(this.orderData.fulfillmentInfo.date),
        estimatedFinishTime: this.momentTime(this.orderData.fulfillmentInfo.estimatedFinishTime)
      }
      this.orderDetailsDialogInfo = {
        title: 'Share Time & Date',
        linkType: 'eventDate',
        serviceDate: event.date,
        meetUpTime: event.time,
        estimatedFinishTime: event.estimatedFinishTime,
        routeDetails: null,
        payoutDetails: null
      }
      if (!this.user.serviceProviderId) {
        this.setUserServiceId()
      }
      this.orderDetailsDialog = true
    },
    textInstructions (segment) {
      // console.log(this.user.serviceProviderId)
      this.usersInSegment = segment.contacts
      let event = {
        time: this.momentTime(this.orderData.fulfillmentInfo.crewTime),
        date: this.moment(this.orderData.fulfillmentInfo.date),
        estimatedFinishTime: this.momentTime(this.orderData.fulfillmentInfo.estimatedFinishTime)
      }
      if(!this.orderData.updateLocations) {
        this.reCalculateLineItemLocationFactors ()
      }
      let instructions = []
      let items = this.orderData.lineItems
      items.forEach(item => {
        instructions.push(item.instruction)
      })
      if (instructions.length !== 0) {
        this.orderDetailsDialogInfo.instructions = instructions
      }
      this.orderDetailsDialogInfo.payoutDetails = null
      this.orderDetailsDialogInfo.title = 'Instructions'
      this.orderDetailsDialogInfo.linkType = 'instructions'
      this.orderDetailsDialogInfo.serviceDate = event.date
      this.orderDetailsDialogInfo.meetUpTime = event.time
      this.orderDetailsDialogInfo.estimatedFinishTime = event.estimatedFinishTime
      this.orderDetailsDialogInfo.routeDetails = {
        travelTimeAndDistance: this.orderData.travelTimeAndDistance,
        locations: this.orderData.locations,
        fulfillmentDateTime: this.orderData.fulfillmentInfo.time + this.orderData.fulfillmentInfo.date,
        crewMeetupInfo: this.orderData.fulfillmentInfo
      }
      if (!this.user.serviceProviderId) {
        this.setUserServiceId()
      }
      this.orderDetailsDialog = true
    },
    textPayOutPlan (segment) {
      // console.log(this.user.serviceProviderId)
      this.usersInSegment = segment.contacts
      let event = {
        time: this.momentTime(this.orderData.fulfillmentInfo.crewTime),
        date: this.moment(this.orderData.fulfillmentInfo.date),
        estimatedFinishTime: this.momentTime(this.orderData.fulfillmentInfo.estimatedFinishTime)
      }
      this.orderDetailsDialogInfo = {
        title: 'Share Payout Plan',
        linkType: 'payout',
        serviceDate: event.date,
        meetUpTime: event.time,
        estimatedFinishTime: event.estimatedFinishTime,
      }
      this.orderDetailsDialogInfo.routeDetails = {
        travelTimeAndDistance: this.orderData.travelTimeAndDistance,
        locations: this.orderData.locations,
        fulfillmentDateTime: this.orderData.fulfillmentInfo.time + this.orderData.fulfillmentInfo.date,
        crewMeetupInfo: this.orderData.fulfillmentInfo
      }
      // console.log(segment)
      let payoutDetails = {}
      if (segment.chip) {
        let segmentRole = this.dispatchData.dispatchRoles
            .find(role => role.title === segment.chip)
        payoutDetails = segmentRole

        // console.log(segmentRole)
        payoutDetails.serviceRequired = segmentRole.title
        if (segmentRole.payoutAtFixedRate) {
          payoutDetails.text = 'Total receivable: $' + segmentRole.fixedRate
        } else {
          payoutDetails.text = 'Rate: $' + segmentRole.ratePerHour + ' /Hr'
        }

        this.orderDetailsDialogInfo.payoutDetails = payoutDetails
      }
      if (!this.user.serviceProviderId) {
        this.setUserServiceId()
      }
      this.orderDetailsDialog = true
    },
    textRoutePlan (segment) {
      // console.log(this.user.serviceProviderId)
      this.usersInSegment = segment.contacts
      let event = {
        time: this.momentTime(this.orderData.fulfillmentInfo.crewTime),
        date: this.moment(this.orderData.fulfillmentInfo.date),
        estimatedFinishTime: this.momentTime(this.orderData.fulfillmentInfo.estimatedFinishTime)
      }
      if(!this.orderData.updateLocations) {
        this.reCalculateLineItemLocationFactors ()
      }
      this.orderDetailsDialogInfo.payoutDetails = null
      this.orderDetailsDialogInfo.title = 'Share Route Plan'
      this.orderDetailsDialogInfo.linkType = 'routePlan'
      this.orderDetailsDialogInfo.serviceDate = event.date
      this.orderDetailsDialogInfo.meetUpTime = event.time
      this.orderDetailsDialogInfo.estimatedFinishTime = event.estimatedFinishTime
      this.orderDetailsDialogInfo.routeDetails = {
        travelTimeAndDistance: this.orderData.travelTimeAndDistance,
        locations: this.orderData.locations,
        fulfillmentDateTime: this.orderData.fulfillmentInfo.time + this.orderData.fulfillmentInfo.date,
        crewMeetupInfo: this.orderData.fulfillmentInfo
      }
      if (!this.user.serviceProviderId) {
        this.setUserServiceId()
      }
      this.orderDetailsDialog = true
    },
    setUserServiceId () {
      // let db = this.$store.state.db
      // let userRef = doc(db, 'users', this.user.uid)
      let userData = this.user
      userData.serviceProviderId = uuid()
      this.$store.dispatch('updateUserProfile', userData)
    },

    reCalculateLineItemLocationFactors () {
      this.orderData.updateLocations = true

      let locations = this.orderData.locations
      let locationData = {locations: locations}
      // console.log(locations)
      if (locations.length > 1) {
        const functions = getFunctions()
        const getTravelTimeAndDistance = httpsCallable(functions, 'getTravelTimeAndDistance')
        return getTravelTimeAndDistance(locationData)
            .then(res => {
              this.orderData.travelTimeAndDistance = res.data.travelTimeAndDistance
              // console.log(res.data.travelTimeAndDistance)
            })
            .catch(err => {
              console.log(err)
            })
      }
    },
    removeMeetupLocation () {
      this.dispatchData.orderData.fulfillmentInfo.crewMeetupLocation = null
      this.updateDispatch()
    },
    saveMeetupLocation (location) {
      this.dispatchData.orderData.fulfillmentInfo.crewMeetupLocation = location
      this.updateDispatch()
    },
    crewStartDatePicked (date) {
      this.crewDate = date
    },
    crewStartTimePicked (time) {
      this.crewTime = time
    },
    setCrewStartTime () {
      this.crewStartTimeDialog = false
      this.dispatchData.orderData.fulfillmentInfo.crewTime = this.crewTime
      this.updateDispatch()
    },
    eventDatePicked (date) {
      this.date = date
    },
    eventTimePicked (time) {
      // console.log(time)
      this.time = time
      this.orderData.fulfillmentInfo.estimatedFinishTime = this.time
    },
    setEventToCalendar () {
      // console.log(this.time)
      this.eventDateTimeDialog = false
      let eventDate = new Date(this.orderData.fulfillmentInfo.date)
      let eventObj = {
        name: this.orderData.clientInfo.name,
        start: this.orderData.fulfillmentInfo.date + ' '
            + this.orderData.fulfillmentInfo.time
        ,
        end: this.date + ' '
            + this.orderData.fulfillmentInfo.estimatedFinishTime
        ,
        color: 'blue',
        timed: true,
        formattedStartDate: eventDate.getTime(),
        orderId: this.id
      }
      // console.log(this.orderData.fulfillmentInfo.date)
      // console.log(eventObj)
      let db = this.$store.state.db
      let scheduleRef =  doc(db, 'users', this.user.uid, 'schedule', this.id)
      let orderRef = doc(db, 'users', this.user.uid, 'orders', this.id)
      setDoc(scheduleRef, eventObj)
          .then (() => {
            return updateDoc(orderRef, this.orderData)
          })

    },
    openEventDateTimeDialog () {
      this.eventDateTimeDialog = true
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    // updateDispatchRoles (value) {
    //   console.log('From Disp')
    //   console.log(value)
    // },
    updateDispatch() {
      let db = this.$store.state.db
      let dispatchRef = doc(db, 'users', this.user.uid + '/dispatch/' + this.id)
      let orderRef = doc(db, 'users', this.user.uid, 'orders', this.id)
      updateDoc(dispatchRef, this.dispatchData)
          .then(() => {
            return updateDoc(orderRef, this.orderData)
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    contactsPicked (segment) {
      console.log(segment)
      let newSegment = {...segment}
      if (this.dispatchData.segments) {
        newSegment.id = segment.id + this.dispatchData.segments.length
        this.dispatchData.segments.push(newSegment)
      } else {
        this.dispatchData
            .segments = []
        newSegment.id = segment.id
        this.dispatchData.segments.push(segment)
      }
      this.updateDispatch()
      // console.log()
    },
    deleteSegment (segment) {
      let index = this.dispatchData.segments.indexOf(segment)
      this.dispatchData.segments.splice(index, 1)
      this.updateDispatch()
      // console.log(index)
    },
    completeDispatch () {
      this.dispatchData.status = 'success'
      let db = this.$store.state.db
      let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', this.id)
      let scheduleRef =  doc(db, 'users', this.user.uid, 'schedule', this.id)
      // console.log(this.dispatchData.contractors)

      updateDoc(fulfillmentRef, {activeContacts: this.dispatchData.contractors})
          .then (() => {
            let activeContacts = this.dispatchData.contractors
            activeContacts.forEach(contact => {
              let activeContactRef = doc(db, 'users', this.user.uid, 'fulfillment',
                  this.id, 'activeContacts', contact.phoneNumber)
              let contactObj = {...contact, requestType: 'setContactsData', fulfillmentData: {...this.orderData.fulfillmentInfo, locations: this.orderData.locations}}
              return setDoc(activeContactRef, contactObj)
            })
          })
          .then(() => {
            return updateDoc(scheduleRef, {fulfillmentData: {activeContacts: this.dispatchData.contractors}})
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
      this.updateDispatch()
    },
    addContractor(contact) {
      //console.log(contact)
      this.dispatchData.contractors.push(contact)
      this.updateDispatch()
    },
    removeContact (contact) {
      console.log(contact)
    },
    removeContractor (contact) {
      let index = this.dispatchData.contractors.indexOf(contact)
      this.dispatchData.contractors.splice(index, 1)
      this.updateDispatch()
      // console.log(index)
    },

  }
}
</script>
